import React, { useState } from "react";
import { Title } from "../../atoms";
import { TabletModal } from "../../molecules";
import NotesIcon from "../../../assets/images/view-note-icon.svg";
import T from "prop-types";

export const ViewLink = ({ text, icon, topText, content, isView }) => {
  const [open, setOpen] = useState(false);
  const onCloseModal = () => {
    setOpen(false);
  };
  console.log("came in the view link comp");
  const onOpenModal = () => {
    setOpen(true);
  };
  return (
    <>
      {isView && (
        <div className="priceBoxView">
          <Title text={topText} className="topText" />
          <div className="viewAnchorSec">
            <a onClick={onOpenModal} target="_blank" className="viewAnchor">
              <img src={icon} />
              <span>{text}</span>
            </a>
          </div>
          <TabletModal
            open={open}
            title={"Comment"}
            onCancel={onCloseModal}
            content={content}
            rightBtnText={""}
            cancelText={"CLOSE"}
            titleClass={"viewBoxTitle"}
          />
        </div>
      )}
    </>
  );
};

ViewLink.T = {
  topText: T.string,
  text: T.string,
  isView: T.bool,
};

ViewLink.defaultProps = {
  icon: NotesIcon,
  text: "View customer comments",
  isView: true,
};
